import {BaseListComponent} from '../../abstract/base-list.component';
import { Directive } from "@angular/core";

@Directive()
export abstract class GetStatementsAction extends BaseListComponent {

  protected statementUrl: string;
  protected _getstatementPdf: string;
  protected _getstatementPdfView: string;
  protected abstract passStatementPdfResponse(res);
  protected abstract passStatementPdfError(err);
  protected abstract passStatementPdfViewResponse(res);
  protected abstract passStatementPdfViewError(err);

  getStatementPdf() {
    this.loadFlag = true;
    this.dataManager.getRequestPdf(this._getstatementPdf, 0).subscribe(
      (res) => {
        this.loadFlag = false;
        this.passStatementPdfResponse((new Blob([res], { type: 'application/pdf' })));
      },
      (err) => {
        this.loadFlag = false;
        this.passStatementPdfError(err);
      },
    );
  }
  getStatementPdfView() {
    this.loadFlag = true;
    this.dataManager.getRequestPdf(this._getstatementPdfView, 0).subscribe(
      (res) => {
        this.loadFlag = false;
        this.passStatementPdfViewResponse((new Blob([res], { type: 'application/pdf' })));
      },
      (err) => {
        this.loadFlag = false;
        this.passStatementPdfViewError(err);
      },
    );
  }
}
